import { render, staticRenderFns } from "./CartSidebar.vue?vue&type=template&id=c56ef684&scoped=true"
import script from "./CartSidebar.vue?vue&type=script&lang=js"
export * from "./CartSidebar.vue?vue&type=script&lang=js"
import style0 from "./CartSidebar.vue?vue&type=style&index=0&id=c56ef684&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c56ef684",
  null
  
)

export default component.exports